import { requestGet } from '@/common/request';

export interface getChannelIntroduceParams {
  id: string;
}

export interface getChannelIntroduceRes {
  ret: string;
  msg: string;
  data: ChannelIntroduceType;
}

export interface ChannelIntroduceType {
  fileOperateList: Array<{ name: string; url: string }> | [];
  fileShopList: Array<{ name: string; url: string }> | [];
  remark: string;
}

//频道介绍查询
export async function getChannelIntroduce(params: getChannelIntroduceParams): Promise<getChannelIntroduceRes> {
  return await requestGet('/channelActivity/getChannelIntroduce', params);
}
